import { ChevronIcon } from 'assets/icons';
import { Pagination } from 'models/pagination';
import { classnames } from 'helpers/utils';
import styles from './paginator-select.module.scss';
import { usePagination } from './use-pagination';

type PaginatorProps = {
  paginationInfo: Pagination;
  notifyGetMoreVaults: (page: number) => void;
};

const PaginationSelect: React.FC<PaginatorProps> = ({
  paginationInfo,
  notifyGetMoreVaults,
}) => {
  const paginationRange = usePagination(
    paginationInfo.lastPage,
    paginationInfo.currentPage,
    1,
    2,
  );

  return (
    <div className={styles.container}>
      <button
        type="button"
        onClick={() => notifyGetMoreVaults(paginationInfo.currentPage - 1)}
        disabled={paginationInfo.currentPage === 1}
      >
        <ChevronIcon
          className={classnames(styles.arrowIcon, styles.leftArrow, {
            [styles.activeArrow]: paginationInfo.currentPage !== 1,
          })}
        />
      </button>
      {paginationRange.map((item) => {
        if (typeof item === 'string') {
          return (
            <span
              key={item}
              className="text__body__regular__small__surfaceDark10"
            >
              ...
            </span>
          );
        }
        return (
          <button
            type="button"
            key={item}
            onClick={() => notifyGetMoreVaults(item)}
          >
            <div key={item} className={styles.paginationNumberItem}>
              <span className="text__body__regular__small__gray800">
                {item}
              </span>
              {paginationInfo?.currentPage === item && (
                <div className={styles.active} />
              )}
            </div>
          </button>
        );
      })}
      <button
        type="button"
        onClick={() => notifyGetMoreVaults(paginationInfo.currentPage + 1)}
        disabled={paginationInfo.currentPage === paginationInfo.lastPage}
      >
        <ChevronIcon
          className={classnames(styles.arrowIcon, styles.rightArrow, {
            [styles.activeArrow]:
              paginationInfo.currentPage !== paginationInfo.lastPage,
          })}
        />
      </button>
    </div>
  );
};

export { PaginationSelect };
